import { useState, useEffect } from 'react';
import { getSyncQueueCount, getFailedSyncCount } from '../offlineDb';
import { sendingCount } from '../utils/inFlight';

export function useSyncStatus() {
  const [pendingCount, setPendingCount] = useState(0);
  const [failedCount, setFailedCount] = useState(0);
  // Requests on their way right now (utils/inFlight.js) — a write is only
  // queued once it FAILS, so the queue alone cannot tell "saved" from "sending".
  const [sending, setSending] = useState(sendingCount());

  useEffect(() => {
    const refresh = async () => {
      setSending(sendingCount());
      try {
        const [pending, failed] = await Promise.all([
          getSyncQueueCount(),
          getFailedSyncCount(),
        ]);
        setPendingCount(pending);
        setFailedCount(failed);
      } catch {
        // IndexedDB not available
      }
    };

    refresh();

    // Update when sync queue changes
    window.addEventListener('syncQueueChanged', refresh);

    // Also poll every 5 seconds as a fallback
    const interval = setInterval(refresh, 5000);

    return () => {
      window.removeEventListener('syncQueueChanged', refresh);
      clearInterval(interval);
    };
  }, []);

  return { pendingCount, failedCount, sendingCount: sending };
}
